module.exports = __webpack_public_path__ + "static/media/matchDetail.29c1541c.png";